import ConsumerRefService from "@api/consumer/consumerRefService";
import {GoalRewardType} from "@interfaces/consumer/refs";
import {FC, useCallback} from "react";
import {toastr} from "@/utils/toastHelper";
import {useNavigate, useParams} from "react-router";
import withPage from "@components/hoc/withPage";
import {GoalRewardFormValues} from "../forms/rewardBaseInfoBlock";
import GoalRewardForm from "./goalRewardForm";

const AddGoalRewardForm: FC = () => {

    const {goal_id} = useParams<{ goal_id: string }>();
    const navigate = useNavigate();

    const initialValues: GoalRewardFormValues = {
        name: '',
        isActive: false,
        order: 0,
        type: GoalRewardType.Balance,
        balance: 100,
        itemId: '',
        count: 1
    };

    const onSubmit = useCallback(async (values: GoalRewardFormValues) => {
        const api = new ConsumerRefService();
        const result = await api.putGoalReward(goal_id || '', values);

        if (result.success) {
            toastr.success("Создание награды", "Награда достижения успешно добавлена");
            navigate(`/consumer/goals/${goal_id}/rewards/${result.data.id}/`, { replace: true });
        }
        else {
            if (result.errorCode === 'GoalNotFound') {
                toastr.error('Создание награды', 'Достижение не найдено');
            }
            else if (result.errorCode === 'RewardNotFound') {
                toastr.error('Создание награды', 'Награда не найдена');
            }
            else if (result.errorCode === 'InvalidRequest') {
                toastr.error('Создание награды', 'Некорректные параметры награды');
            }
            else if (result.errorCode === 'DisabledItem') {
                toastr.error('Создание награды', 'Предмет отключен');
            }
            else if (result.errorCode === 'InvalidType') {
                toastr.error('Создание награды', 'Некорректный тип награды');
            }
            else {
                toastr.error('Создание награды', 'Неизвестная ошибка');
            }
        }
    }, [goal_id, navigate]);

    return (
        <GoalRewardForm
            initialValues={initialValues}
            onSubmit={onSubmit}
            editForm={false}
            title="Создание награды"
            cancelUrl={`/consumer/goals/${goal_id}/rewards/`}
        />
    )
}

export default withPage(AddGoalRewardForm);
